import { SquaresPlusIcon } from '@heroicons/react/24/solid';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button, useDisclosure } from '@nextui-org/react';
import _ from 'lodash';
import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { z } from 'zod';

import { AddServerSchema, addServerSchema, serverSchema, ServerSchema } from '@common/types';
import { TypographyUI } from '@portal/components/common/Typography.ui';
import { ServerFormUI } from '@portal/components/Server.Form.ui';
import { tsrestClient } from '@portal/provider/tsrest';

export const AddServer = (/*props: AddServerUIProps*/) => {
  const { isOpen, onOpen, onClose, onOpenChange } = useDisclosure();

  const { data, refetch } = tsrestClient.servers.get.useQuery(['servers'], {
    headers: {
      authorization: localStorage.getItem('token') || '',
    },
  });
  const addServerMutation = tsrestClient.servers.add.useMutation({
    onSettled: () => {
      refetch();
    },
    onError: (e, variables) => {
      toast(
        <>
          <TypographyUI className='font-bold'>Cannot add server &apos;{variables.body.name}&apos;</TypographyUI>
          <TypographyUI className='text-ts'>error: {(e.body as any).message}</TypographyUI>
        </>,
        {
          type: 'error',
        }
      );
    },
    onSuccess: (_, variables) => {
      toast(`Server '${variables.body.name}' is successfully added`, { type: 'info' });
    },
  });

  const addServerForm = useForm<AddServerSchema>({
    resolver: zodResolver(addServerSchema),
    mode: 'all',
    defaultValues: {
      name: '',
      clusterTag: '',
      host: '',
      sshPort: 22,
      phpPort: 80,
      connectionType: 'persistent-ssh',
      sshUsername: '',
      sshPassword: '',
    },
  });
  const {
    control,
    register,
    formState: { errors, isSubmitting, isValid, isDirty },
    handleSubmit,
    reset,
  } = addServerForm;

  const showModal = () => {
    reset();
    onOpen();
  };
  const onSubmitAndClose = async (data: AddServerSchema) => {
    await onSubmit(data);
    onClose();
  };
  const onSubmit = async (data: AddServerSchema) => {
    await addServerMutation.mutate({
      body: data,
      headers: {
        authorization: localStorage.getItem('token') || '',
      },
    });
    await refetch();
  };

  return (
    <>
      <Button color='primary' variant='shadow' size='sm' onPress={showModal} className='w-[130px]'>
        <SquaresPlusIcon strokeWidth={2} className='h-4 w-4' /> Add Server
      </Button>
      <ServerFormUI
        modalVisible={isOpen}
        onModalVisibleChange={onOpenChange}
        control={control}
        register={register}
        errors={errors}
        isSubmitting={isSubmitting}
        isSubmitValid={!(!isValid || !isDirty)}
        onSubmitAndClose={handleSubmit(onSubmitAndClose)}
        onSubmit={handleSubmit(onSubmit)}
      />
    </>
  );
};
